<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>


<style>
.ql-feat-picture img{
	width:100%;
	height:100%;
}
.loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0);
  z-index: 9999;
}

.loading.hide {
  display: none;
}

.loading .logo {
  position: absolute;
  width: 3.733333rem;
  height: 3.733333rem;
  top: 50%;
  left: 50%;
  -webkit-transform: translateX(-50%) translateY(-50%);
     -moz-transform: translateX(-50%) translateY(-50%);
          transform: translateX(-50%) translateY(-50%);
  -webkit-border-radius: 0.373333rem;
          border-radius: 0.373333rem;
  background-color: #fff;
  padding: 0.533333rem;
  -webkit-box-sizing: border-box;
     -moz-box-sizing: border-box;
          box-sizing: border-box;
  -webkit-box-shadow: 0 0 0.533333rem 0 rgba(0, 0, 0, 0.05);
          box-shadow: 0 0 0.533333rem 0 rgba(0, 0, 0, 0.05);
  text-align: center;
}

.loading .logo img {
  height: 1.893333rem;
  -webkit-animation: pageLoadingImgAnimation--xabytdflzks 1.6s infinite ease;
     -moz-animation: pageLoadingImgAnimation--xabytdflzks 1.6s infinite ease;
          animation: pageLoadingImgAnimation--xabytdflzks 1.6s infinite ease;
}

.loading .logo p {
  position: absolute;
  left: 0;
  bottom: 0.533333rem;
  width: 100%;
  color: #999;
  line-height: 1.4;
  text-align: center;
  white-space: nowrap;
}

[data-dpr="1"] .loading.logo p {
  font-size: 12px;
}

[data-dpr="2"] .loading .logo p {
  font-size: 24px;
}

[data-dpr="3"] .loading .logo p {
  font-size: 36px;
}

@-webkit-keyframes pageLoadingImgAnimation {
  0% {
    -webkit-transform: translate3d(-0.053333rem, 0.146667rem, 0);
            transform: translate3d(-0.053333rem, 0.146667rem, 0);
  }

  30% {
    -webkit-transform: translate3d(0.053333rem, -0.146667rem, 0);
            transform: translate3d(0.053333rem, -0.146667rem, 0);
  }

  100% {
    -webkit-transform: translate3d(-0.053333rem, 0.146667rem, 0);
            transform: translate3d(-0.053333rem, 0.146667rem, 0);
  }
}

@-moz-keyframes pageLoadingImgAnimation {
  0% {
    -moz-transform: translate3d(-0.053333rem, 0.146667rem, 0);
         transform: translate3d(-0.053333rem, 0.146667rem, 0);
  }

  30% {
    -moz-transform: translate3d(0.053333rem, -0.146667rem, 0);
         transform: translate3d(0.053333rem, -0.146667rem, 0);
  }

  100% {
    -moz-transform: translate3d(-0.053333rem, 0.146667rem, 0);
         transform: translate3d(-0.053333rem, 0.146667rem, 0);
  }
}

@keyframes pageLoadingImgAnimation {
  0% {
    -webkit-transform: translate3d(-0.053333rem, 0.146667rem, 0);
       -moz-transform: translate3d(-0.053333rem, 0.146667rem, 0);
            transform: translate3d(-0.053333rem, 0.146667rem, 0);
  }

  30% {
    -webkit-transform: translate3d(0.053333rem, -0.146667rem, 0);
       -moz-transform: translate3d(0.053333rem, -0.146667rem, 0);
            transform: translate3d(0.053333rem, -0.146667rem, 0);
  }

  100% {
    -webkit-transform: translate3d(-0.053333rem, 0.146667rem, 0);
       -moz-transform: translate3d(-0.053333rem, 0.146667rem, 0);
            transform: translate3d(-0.053333rem, 0.146667rem, 0);
  }
}
.avatar img{
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue